const activeCenter = [
  {
    path: "active",
    name: "active",
    meta: {
      title: "活动列表"
    },
    component: () => import("@/views/activeCenter/index.vue")
  },
  {
    path: "adActive",
    name: "adActive",
    meta: {
      title: "操作活动"
    },
    component: () => import("@/views/activeCenter/adActive.vue")
  },
  {
    path: "applicat",
    name: "applicat",
    meta: {
      title: "报名列表"
    },
    component: () => import("@/views/activeCenter/applicat.vue")
  }
];

export default activeCenter;
